import React from "react"
import Button from "@convertkit/design/button"

export default function TrialNav({ userInfo, daysLeft }) {
  const showCountdown = userInfo.trialing
  const showUpgradeButton = userInfo.trialing

  return (
    <React.Fragment>
      <div className="flex">
        {showCountdown && (
          <div className="my-auto mx-5 text-kit-black">
            Trial: {daysLeft} remaining
          </div>
        )}

        {showUpgradeButton && (
          <Button color="green" size="sm" href="/upgrade">
            Upgrade now
          </Button>
        )}
      </div>
    </React.Fragment>
  )
}
